<template>
  <div class="autocomplete">
    <input
      v-model="search"
      type="text"
      class="form-control"
      @input="onChange"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
    >
    <ul
      v-show="isOpen"
      id="autocomplete-results"
      class="autocomplete-results"
    >
      <li
        v-if="isLoading"
        class="loading"
      >
        Carregando ...
      </li>
      <li
        v-for="(result, i) in results"
        v-else
        :key="i"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
        @click="setResult(result)"
      >
        {{ result.text }}
      </li>
    </ul>
  </div>
</template>
<script>
import debounce from '../../admin/js/infra/debounce';

export default {
  props: {
    service: {
      type: Object,
      required: false,
      default: null,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    value: {
      type: Object,
      required: false,
      default: () => ({
        value: null,
        text: null,
      }),
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      results: [],
      search: '',
      isLoading: false,
      arrowCounter: 0,
      selected: {
        value: null,
        text: null,
      },
    };
  },
  watch: {
    items(val, oldValue) {
      // actually compare them
      if (val.length !== oldValue.length) {
        this.results = val;
        this.isLoading = false;
      }
    },
    value(val, oldVal) {
      if (!val.value && !val.text) {
        this.search = null;
        this.selected = {
          value: null,
          text: null,
        };
      }

      if (val === oldVal || !val.value) {
        return;
      }

      if (val) {
        this.results = [val];
        this.selected = val;
        this.search = val.text;
      } else {
        this.results = [];
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    onChange: debounce(function () {
      // Is the data given by an outside ajax request?
      if (this.isAsync) {
        this.isLoading = true;
        this.requestAjaxData();
      } else {
        // Let's  our flat array
        this.filterResults();
        this.toggleItems(true);
      }
    }, 500),
    async requestAjaxData() {
      if (this.search.length <= 0) {
        this.results = [];
        this.isLoading = false;
        this.toggleItems(false);
      }
      this.results = await this.service.all(this.search.toLowerCase());
      this.isLoading = false;
      this.toggleItems(true);
    },
    toggleItems(opened) {
      if (this.search.length <= 0 || this.results.length <= 0) {
        this.isOpen = false;
        this.isLoading = false;
        return;
      }
      this.isOpen = opened;
    },
    filterResults() {
      // first uncapitalize all the things
      this.results = this.items
        .filter((item) => item.text.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
    },
    setResult(result) {
      this.search = result.text;
      this.selected = result;
      this.isOpen = false;
      // Let's warn the parent that a change was made
      this.$emit('input', this.selected);
      this.$emit('onSetValue', this.selected.value);
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      const def = {
        text: this.search,
        value: null,
      };
      const result = this.results[this.arrowCounter];
      const object = result || def;

      this.setResult(object);
      this.arrowCounter = -1;
    },
    handleClickOutside() {
      if (this.selected.text !== this.search) {
        this.isOpen = false;
        this.arrowCounter = -1;
        this.setResult({
          value: null,
          text: this.search,
        });
      }
    },
  },
};
</script>


<style>
    .autocomplete {
        position: relative;
    }

    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #eeeeee;
        height: 120px;
        overflow: auto;
        width: 100%;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 2px;
        cursor: pointer;
    }

    .autocomplete-result.is-active,
    .autocomplete-result:hover {
        background-color: #008596;
        color: white;
    }

</style>
